export const sessionIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.report-section-header',
    intro: 'The Session Summary is where you can track student usage minutes and sessions.'
  },
  {
    element: '.filter-options',
    intro: 'Use these filters to narrow down the students by grade or class.'
  },
  {
    element: '.session-coteacher-container',
    intro: 'Select this box to hide students who have been shared with you. Once enabled, the report will only display those you are directly assigned to — excluding any students you’re listed as a co-teacher for.'
  },
  {
    element: '#refresh-button',
    intro: 'Click here to refresh the Session Summary.'
  },
  {
    element: '#export-button',
    intro: 'Click here to export the report data for analysis and sharing.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Session Summary for the selected date range and View.'
  },
  {
    element: '#date-controls-container',
    intro: 'Use these data controls to select the time period for which you want to view session or minutes data.'
  },
  {
    element: '#student-wrapper',
    intro: 'Select all students or a specific student to see their Session Summary data.'
  },
  {
    element: '#view-wrapper',
    intro: 'Select Sessions or Minutes from the dropdown.'
  },
  {
    element: 'table.report-table',
    intro: 'See the student session or minutes data. The table includes the date, student Name, start time and end time for the Sessions View. The table includes the date, student name and minutes for the Minutes View. Click the top of any column to sort the column.'
  }
];
